/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 609e3fa414d6
 */

import * as z from "zod";
import {
  StreamingProfile,
  StreamingProfile$zodSchema,
} from "./streamingprofile.js";

export type StreamingProfileDataResponse = { data: StreamingProfile };

export const StreamingProfileDataResponse$zodSchema: z.ZodType<
  StreamingProfileDataResponse
> = z.object({
  data: StreamingProfile$zodSchema,
});
